import request from 'utils/request'

// 获取表格数据
export const getTableData = data => request().post('score/batchCalc/page', data)

// 获取业务类型列表
export const getBusinessList = () => request().get('business/jsonList')
/**
 * 获取 大区 | 业务模式 | 信控区列表
 */
export const getRegionList = data =>
  request().post('business/region/list', data)
/**
 * 获取信用主管审批人列表
 */
export const getManagerList = () => request().get('bp/apply/listCManager')

// 批量运行(9类)
export const batchCalc = data => request().post('score/batchCalc', data)

// 批量运行(自定义)
export const batchCalcCard = data => request().post('score/batchCalcCard', data)

// 下载
export const download = id =>
  request().get(`score/batchCalc/export/${id}`, { responseType: 'blob' })

// 下载自定义批量评分卡
export const downloadCard = id =>
  request().get(`score/batchCalcCard/export/${id}`, { responseType: 'blob' })

// 获取业务类型冻结列表
export const getFreezeBgList = () =>
  request().get('business/jsonList/getFreezeBgList')

// 获取业务模式冻结列表
export const getFreezeModelList = () =>
  request().get('business/jsonList/getFreezeModelList')

// 获取评分卡LIST[] ,不包含“冻结”状态的
export const getRating = () => request().post('card/selectRating/list')

// 批量评估(9类)
export const batchCalcList = data =>
  request().post('score/file/upload/calc', data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })

// 批量评估(自定义)
export const batchCalcCardList = data =>
request().post('score/file/upload/calcCard', data, {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
})

/**
 * 下载项额度批量申请模板
 */
export const templateDownload = () =>
  request().get('score/download', { responseType: 'blob' })